import { getProgressPercentage } from '@/utils/getProgressPercentage';
import { Progress } from '../ui/progress';
import { AssignmentResponse } from '@/types';

interface AssignmentProgressProps {
  assignment: AssignmentResponse;
}

export function AssignmentProgress({ assignment }: AssignmentProgressProps) {
  return (
    <div>
      <div className='flex items-center justify-between text-sm mb-1'>
        <span>Overall Progress</span>
        <span>{Math.round(getProgressPercentage(assignment.status))}%</span>
      </div>
      <Progress
        value={getProgressPercentage(assignment.status)}
        className='h-2'
      />
    </div>
  );
}
